<template>
  <div class="flex items-center justify-center min-h-screen bg-[#F5F0E8]">
    <p class="text-ink/70 text-15">Завершаем вход...</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '../store/auth.js'
import router from '../router/index.js'

// VK ID возвращает code и device_id; code_verifier мы клали в sessionStorage
// перед редиректом — без него обмен кода не пройдёт (PKCE обязателен).
onMounted(async () => {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const deviceId = params.get('device_id')
  const state = params.get('state')

  const verifier = sessionStorage.getItem('vk-code-verifier')
  const savedState = sessionStorage.getItem('vk-state')
  sessionStorage.removeItem('vk-code-verifier')
  sessionStorage.removeItem('vk-state')

  const fail = () => {
    if (window.opener) {
      window.opener.postMessage({ type: 'vk-error' }, window.location.origin)
      window.close()
    } else {
      router.replace('/onboarding')
    }
  }

  // state защищает от подмены ответа: если он не совпал, это не наш редирект.
  if (!code || !deviceId || !verifier || (savedState && state !== savedState)) return fail()

  const authStore = useAuthStore()
  const redirectUri = `${window.location.origin}/auth/vk/callback`
  const credentials = { code, code_verifier: verifier, device_id: deviceId, redirect_uri: redirectUri, state }

  const storedUser = JSON.parse(localStorage.getItem('zoya-user') || 'null')
  if (storedUser?.is_guest) {
    if (window.opener) {
      window.opener.postMessage({ type: 'vk-code', credentials }, window.location.origin)
      window.close()
    } else {
      try {
        await authStore.linkGuestAccount('vk', credentials)
        router.replace(authStore.user?.onboarding_done ? '/diary' : '/onboarding')
      } catch {
        router.replace('/profile')
      }
    }
    return
  }

  try {
    await authStore.loginWithVk(credentials)
  } catch {
    return fail()
  }

  if (window.opener) {
    window.opener.postMessage({ type: 'vk-auth-done' }, window.location.origin)
    window.close()
  } else if (authStore.user?.onboarding_done) {
    router.replace('/diary')
  }
})
</script>
